import { HttpClient } from '@angular/common/http';

import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

export interface IProviderServices{
  image:string;
  name :string;
  program_id_gnx: string;
  sku : string;
  }

@Injectable({
  providedIn: 'root'
})

export class PaymentServicesService {

  constructor(
    private storageServices : StorageService,
    private http : HttpClient

  ) { }

  async getProviders(): Promise<IProviderServices[]>{
    const claims = await this.storageServices.get("gnx-claims");
    return new Promise((resolve, reject) =>
      this.http
        .get(`${environment.gluky.productsApiBasePath}/products/user/${claims.uid}/public-services`, )
        .subscribe(
          async (res:any) => {
            resolve(res.data);
          },
          (err) => {
            reject(console.log("productsApiBasePath does not have permission", err));
          }
        )
    );
  }

  async savepaymentServices(data){
     const claims = await this.storageServices.get("gnx-claims");
    return new Promise((resolve, reject) =>
      this.http
        .post(`${environment.gluky.ordersApiBasePatch}/user-orders/${claims.uid}`,data )
        .subscribe(
          async (res:any) => {
            resolve(res);
          },
          (err) => {
            reject(err.error);
          }
        )
    );
  }
  async CalculateValueServicesUser(data){
    const claims = await this.storageServices.get("gnx-claims");
    return new Promise((resolve, reject) =>
      this.http
        .post(`${environment.gluky.ordersApiBasePatch}/user-orders/${claims.uid}/calculate-price`,data )
        .subscribe(
          async (res:any) => {
            resolve(res);
          },
          (err) => {
            reject(console.log("CalculateValueServicesUser has error ", err));
          }
        )
    );
  }
  async CalculateValueServices(data){
    return new Promise((resolve, reject) =>
      this.http
        .post(`${environment.gluky.ordersApiBasePatch}/public-services/calculate-price`,data )
        .subscribe(
          async (res:any) => {
            resolve(res);
          },
          (err) => {
            reject(console.log("productsApiBasePath does not have permission", err));
          }
        )
    );
  }
  
}
